import React, {useState, useRef, useEffect} from "react";
import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import {Fieldset} from "primereact/fieldset";
import {Card} from 'primereact/card';
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Calendar} from "primereact/calendar";
import Spinner from "../../spinner/Spinner";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputTextarea} from "primereact/inputtextarea";
import {Dialog} from "primereact/dialog";
import axios from "axios";
import {Message} from "primereact/message";
import {Carousel} from "primereact/carousel";
import descripiton_png from "../../assets/flags/cloud/reservation/descripiton.png";
import flavorselect_png from "../../assets/flags/cloud/reservation/flavorselect.png";
import starttime_png from "../../assets/flags/cloud/reservation/starttime.png";
import {Tag} from "primereact/tag";
import {InputText} from "primereact/inputtext";


const ReservationRequest = props => {
    const toast = useRef(null);
    const [resvID, setResvID] = useState('');
    const [resvStartTime, setResvStartTime] = useState(null);
    const [resvFinishTime, setResvFinishTime] = useState(null);
    const [resvReason, setResvReason] = useState('');
    const [resvInstitution, setResvInstitution] = useState('');
    const [loadingState, setLoadingState] = useState(false);
    const [reservedCredit, setReservedCredit] = useState(50);
    const [flavors, setFlavors] = useState([]);
    const [selectedFlavor, setSelectedFlavor] = useState(null);
    const [credit, setCredit] = useState(null);
    const [cpuLimit, setCpuLimit] = useState(null);
    const [gpuLimit, setGpuLimit] = useState(null);
    const [ramLimit, setRamLimit] = useState(null);
    const [diskLimit, setDiskLimit] = useState(null);
    const [infoDialog, setInfoDialog] = useState(false);
    const [isCredit, setIsCredit] = useState(true);
    const [startDate, setStartDate] = useState(new Date());
    const [finishDate, setFinishDate] = useState(new Date());
    const [minRezDate, setMinRezDate] = useState(new Date());
    const [legalDisplay, setLegalDisplay] = useState('none');
    const [maxRez, setMaxRez] = useState(0);


    useEffect(() => {
            resultMaxRez();
            getFlavors();
            getSourceLimits();
            startDate.setDate(startDate.getDate() + 1);
            finishDate.setDate(finishDate.getDate() + 1);
        }
        ,
        []
    );


    const showSuccess = (message) => {
        toast.current.show({severity: 'success', life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const getSourceLimits = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        // setLoadingState(true);
        axios.get('api/user-limits/', {"headers": headers, method: "GET"})
            .then(res => {
                // setLoadingState(false);
                const data = res.data;
                if (data.result) {
                    if (data.limits["credit"] <= 0 || data.limits["credit"] === null) {
                        setCredit(0);
                        setIsCredit(true);
                    } else {
                        setCredit(data.limits["credit"]);
                        setIsCredit(false);
                    }
                    setCpuLimit(data.limits["cpu_limit"]);
                    setGpuLimit(data.limits["gpu_limit"]);
                    setRamLimit(data.limits["ram_limit"]);
                    setDiskLimit(data.limits["disk_limit"]);
                } else {
                    setCredit(0);
                    setIsCredit(true);
                }
            })
    }

    const getFlavors = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/cloud-flavor/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setFlavors(data.flavors);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const convert_time_format = (date_time) => {
        const start_time =
            ("00" + date_time.getDate()).slice(-2) + "/" +
            ("00" + (date_time.getMonth() + 1)).slice(-2) + "/" + date_time.getFullYear();
        return start_time;
    }

    const submit = () => {
        // console.log(selectedFlavor.flavor_id,resvStartTime,resvFinishTime,"*****")
        if (selectedFlavor === null || resvStartTime === null || resvFinishTime === null) {
            showError("Lütfen istenen tüm bilgileri giriniz!");
        } else {
            const obj = {
                flavID: selectedFlavor.flavor_id,
                resvID: resvID,
                resvReason: resvReason,
                resvInstitution: resvInstitution,
                resvStartTime: convert_time_format(resvStartTime),
                resvFinishTime: convert_time_format(resvFinishTime),
                reservedCredit: reservedCredit
            };

            let headers = {"Content-Type": "application/json"};
            let token = localStorage.getItem("token");

            if (token) {
                headers["Authorization"] = `Token ${token}`;
                const body = JSON.stringify(obj);
                if (resvID) {
                    fetch("/api/reservations" + "/" + resvID + "/", {headers, method: "PUT", body})
                        .then(res => {
                            if (res.status < 500) {
                                return res.json().then(data => {
                                    return {status: res.status, data};
                                })
                            } else {
                                //console.log("Server Error!");
                                throw res;
                            }
                        })
                        .then(res => {
                            if (res.status === 200) {
                                const data = res.data;

                                if (data.result) {
                                    window.location.hash = '/my-reservations'

                                    showSuccess(data.message);
                                } else {
                                    showError(data.message);
                                    // this.setState({disable_submit_btn: false});
                                }
                            } else if (res.status === 401) {
                                props.loadUser();
                                throw res.data;

                            } else if (res.status === 403) {
                                throw res.data;

                            }
                        })
                } else {
                    headers["Authorization"] = `Token ${token}`;
                    const body = JSON.stringify(obj);
                    // console.log(body, "---")

                    fetch("/api/reservations/", {headers, method: "POST", body})
                        .then(res => {
                            if (res.status < 500) {

                                return res.json().then(data => {
                                    return {status: res.status, data};
                                })
                            } else {
                                throw res;
                            }
                        })
                        .then(res => {
                            if (res.status === 200) {


                                const data = res.data;
                                if (data.result) {
                                    window.location.hash = '/my-reservations'


                                    showSuccess(data.message);
                                    // setData(data.result)
                                } else {
                                    showError(data.message);
                                    // this.setState({disable_submit_btn: false});
                                }
                            } else if (res.status === 401) {
                                props.loadUser();
                                throw res.data;

                            } else if (res.status === 403) {
                                throw res.data;

                            }
                        })
                }
            }

        }
    }

    const downloadReservationGuide = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            axios.get("api/reservation/download/", {
                headers,
                responseType: "blob"
            }).then((response) => {
                let blob = new Blob([response.data],),
                    downloadUrl = window.URL.createObjectURL(blob),
                    filename = "",
                    disposition = response.headers["content-disposition"];

                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }

                let a = document.createElement("a");
                if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
            }).catch((error) => {
                // ...
            });
        }
    }
    const resultMaxRez = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/max-rez-time/', {"headers": headers})
            .then(res => {
                let limit = res.data.result
                setMaxRez(limit['maxRezTime'])
            })
            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return {status: res.status, data};
                    })
                } else {
                    //console.log("Server Error!");
                    throw res;
                }
            })

            .then(res => {

                if (res.status === 401) {
                    props.loadUser();
                    throw res.data;
                } else if (res.status === 403) {
                    throw res.data;
                }
            })
    }

    const getFlavorBody = (span_name, data_key) => {
        const flavorBody = (rowData) => {
            return (
                <React.Fragment>
                    <span className="p-column-title">{span_name}</span>
                    {rowData[data_key]}
                </React.Fragment>
            );
        }

        return flavorBody;
    }
    const products = [
        {
            "src": flavorselect_png,
            "name": "Rezervasyon Oluşturma Adım 1",
            "text": <p style={{fontSize: '15px'}}>
                Rezervasyon talebinde bulunmak için öncelikle <b>"Şablon Seçimi"</b> alanında yer alan
                kaynakların (CPU, GPU, RAM, DİSK) boyutlarıyla verilen şablonlar listesinden
                kullanmak istediğiniz şablonu seçmeniz gerekmektedir.

            </p>
        },
        {
            "src": starttime_png,
            "name": "Rezervasyon Oluşturma Adım 2",
            "text": <p style={{fontSize: '15px'}}>
                Şablon Seçimi yapıldıktan sonra kullanmak istediğiniz kaynağı hangi tarihler arasında kiralama talebinde
                bulunacağınızı belirtmek için <b>Başlangıç Tarihi</b> ve <b>Bitiş Tarihi</b> seçimi yapmanız
                gerekmektedir.
            </p>
        },
        {
            "src": descripiton_png,
            "name": "Rezervasyon Oluşturma Adım 3",
            "text": <p style={{fontSize: '15px'}}>
                Tarih seçimi yaptıktan sonra <b>Rezervasyon Açıklaması</b> alanına
                talep etme amacı hakkında bilgi verilir. Sonra <b>Rezervasyon Oluştur</b> butonuna tıklanarak talep
                oluşturulur.
                Talep oluşturulduktan sonra <b>Rezervasyon Taleplerim</b> sayfasına yönlendirilirsiniz.
            </p>
        },
    ];

    const productTemplate = (product) => {
        return (
            <div className="product-item">
                <div className="product-item-content">
                    <div className="p-mb-3">
                        <img src={product.src} alt={product.name} width='100%'
                             style={{objectFit: 'contain', maxHeight: '500px'}}/>
                    </div>
                    <div>
                        <h4 className="p-mb-1">{product.name}</h4>
                        <h6 className="p-mt-0 p-mb-3">{product.text}</h6>
                    </div>
                </div>
            </div>
        );
    }

    const onChangeStartDate = (value) => {
        const date = new Date();
        var year = value.getFullYear();
        var month = value.getMonth();
        var day = value.getDate();

// Seçilen tarihe 1 gün ekle
        var nextDay = new Date(year, month, day + 1);

// Ay ve yıl sınırlarını kontrol et
        if (nextDay.getMonth() !== month) {
            // Ay sınırını aştığında, bir sonraki ayın ilk gününü ayarla
            nextDay = new Date(year, month + 1, 1);
        }
        if (nextDay.getFullYear() !== year) {
            // Yıl sınırını aştığında, bir sonraki yılın ilk ayının ilk gününü ayarla
            nextDay = new Date(year + 1, 0, 1);
        }
        setMinRezDate(nextDay)
        var date2 = new Date(value);
        date.setMonth(date2.getMonth() + maxRez);


        console.log(date, "---------")
        // date.setDate(resvStartTime.getDate() + (maxRez * 31));
        setFinishDate(date);
        setResvStartTime(value);
    }
    const individualApplications = () => {
        setResvStartTime('')
        setResvFinishTime('')
        setResvReason('')
        setSelectedFlavor('')
        setLegalDisplay('none')
    }
    const legalApplications = () => {
        setResvStartTime('')
        setResvFinishTime('')
        setResvReason('')
        setSelectedFlavor('')
        setLegalDisplay('block')
    }


    return (
        <div className="p-fluid" style={{fontSize: 'large'}}>
            <Toast ref={toast}/>
            <Spinner loadingState={loadingState}/>
            <div className="p-grid">
                <div className="p-col-10 p-sm-10 p-md-6 p-lg-6 p-xl-2">
                    <Button icon="pi pi-file-pdf" className="p-button-danger p-button-rounded p-mb-5"
                            label="Rezervasyon Rehber Kılavuzu"
                            tooltip="Rezervasyon Rehber Kılavuzu İndir"
                            onClick={(e) => downloadReservationGuide()}/>
                </div>
                <div className="p-col-10 p-sm-10 p-md-6 p-lg-6 p-xl-2">
                    <Button icon="pi pi-info" className="p-button-secondary p-button-rounded"
                            label="Rezervasyon Oluşturma Adımları"
                            onClick={() => setInfoDialog(true)}/>
                </div>

            </div>
            <div className="p-grid p-mt-3">
                <div className="p-col-12 p-sm-12 p-md-3 p-lg-2 p-xl-2">
                    <Button label="Kaynak Limiti"
                            icon="pi pi-angle-double-right"
                            className="p-button-text p-button-raised p-button-rounded"
                            iconPos="right"
                            disabled
                    />
                </div>
                <div className="p-col-12 p-md-1">
                    <Button label={cpuLimit ? "CPU : " + cpuLimit : <span>CPU : -</span>}
                            icon="pi pi-info-circle"
                            style={{fontSize: '11px'}}
                            className="p-button-success p-button-text"/>
                </div>
                <div className="p-col-12 p-md-1">
                    <Button label={gpuLimit ? "GPU : " + gpuLimit : <span>GPU : -</span>}
                            icon="pi pi-info-circle"
                            style={{fontSize: '11px'}}
                            className="p-button-success p-button-text"/>
                </div>
                <div className="p-col-12 p-md-1">
                    <Button label={ramLimit ? "RAM : " + ramLimit : <span>RAM : -</span>}
                            icon="pi pi-info-circle"
                            style={{fontSize: '11px'}}
                            className="p-button-success p-button-text"/>
                </div>
                <div className="p-col-12 p-md-1">
                    <Button label={diskLimit ? "DİSK : " + diskLimit : <span>DİSK : -</span>}
                            icon="pi pi-info-circle"
                            style={{fontSize: '11px'}}
                            className="p-button-success p-button-text"/>
                </div>
                <div className="p-col-12 p-sm-12 p-md-1 p-lg-4 p-xl-4"/>
                <div className="p-col-12 p-sm-12 p-md-4 p-lg-2 p-xl-2" align="right">
                    <Button label="Mevcut Krediniz" icon="pi pi-money-bill"
                            className="p-button-rounded p-button-info"
                            disabled>
                        <Tag className="p-ml-2" severity="warning" style={{fontSize: '12px'}} value={credit}/>
                    </Button>
                </div>
            </div>
            <div className="p-grid p-mt-6 p-mb-3" style={{textAlignLast: 'center'}}>
                <div className="p-col-6">
                    <Button label="Bireysel Başvuru" className="p-button-rounded p-button-info" style={{width: '75%'}}
                            onClick={individualApplications}
                    />

                </div>
                <div className="p-col-6">
                    <Button label="Kurumsal Başvuru" className="p-button-rounded p-button-warning"
                            style={{width: '75%'}}
                            onClick={legalApplications}/>
                </div>

            </div>

            <Card className="p-card-content">


                <div className="p-grid" style={{justifyContent: 'space-evenly'}}>
                    <div className="p-col-12">
                        {isCredit
                            ?
                            <Message severity="warn"
                                     text="Krediniz Bulunmamaktadir. Lütfen Kredi Talebinde Bulununuz."/>
                            :
                            null
                        }
                    </div>


                    <div className="p-col-12 p-md-8">
                        <div className="p-mt-4" style={{display: legalDisplay}}>
                            <Fieldset legend="Kurum Bilgisi Giriniz" toggleable>

                                <div className="p-col-12 p-md-12">
                                    <InputText value={resvInstitution}
                                               placeholder="Kurum Adı Giriniz"
                                               onChange={(e) => setResvInstitution(e.target.value)}
                                               rows={5} cols={30}/>


                                </div>
                                <Message severity="info"
                                         className="p-mt-1"
                                         text="Bu alana kurum bilginizi giriniz."/>

                            </Fieldset>

                        </div>
                        <div className="p-md-12">
                            <Fieldset legend="Şablon Seçimi" toggleable>

                                <div className="datatable-responsive-demo">
                                    <DataTable
                                        selectionMode="single" selection={selectedFlavor}
                                        onSelectionChange={e => setSelectedFlavor(e.value)}
                                        value={flavors}
                                        scrollable
                                        scrollHeight="250px"
                                        className="p-datatable-responsive-demo p-datatable-sm"
                                        rowHover
                                        emptyMessage="Kayıt Bulunamadı"
                                    >
                                        <Column field="flavor_id" header="ID" style={{display: 'none'}}
                                        />
                                        <Column field="cpu" header="CPU"
                                                body={getFlavorBody("CPU", "cpu")}
                                                style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                        />
                                        <Column field="gpu" header="GPU"
                                                body={getFlavorBody("GPU", "gpu")}
                                                style={{textAlign: 'center', width: '5.5em'}}
                                        />
                                        <Column field="ram" header="RAM"
                                                body={getFlavorBody("RAM", "ram")}
                                                style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                        />
                                        <Column field="disk" header="DİSK"
                                                body={getFlavorBody("DİSK", "disk")}
                                                style={{textAlign: 'center', width: '5.5em'}}
                                        />
                                    </DataTable>
                                    <Message severity="info"
                                             className="p-mt-1"
                                             text="Bu alanda sunucu oluştururken kullanılacak olan şablon seçilmelidir."/>
                                </div>
                            </Fieldset>

                        </div>

                        <Fieldset legend="Başlangıç Tarihi" toggleable>

                            <div className="p-col-12 p-md-12">
                                <Calendar
                                    minDate={startDate}
                                    showIcon
                                    placeholder="Başlangıç Tarihi"
                                    hideOnDateTimeSelect={true}
                                    dateFormat="dd/mm/yy"
                                    locale="tr"
                                    id="time24"
                                    value={resvStartTime}
                                    onChange={(e) => onChangeStartDate(e.value)}
                                />
                                <Message severity="warn"
                                         className="p-mt-1"
                                         text="Rezervasyon başlama tarihinden sonra krediniz günlük düşecektir."/>
                            </div>

                        </Fieldset>

                        <div className="p-mt-4">
                            <Fieldset legend="Bitiş Tarihi" toggleable>

                                <div className="p-col-12 p-md-12">
                                    <Calendar
                                        maxDate={finishDate}
                                        minDate={minRezDate}
                                        showIcon
                                        placeholder="Bitiş Tarihi"
                                        hideOnDateTimeSelect={true}
                                        dateFormat="dd/mm/yy"
                                        locale="tr"
                                        id="time24"
                                        value={resvFinishTime}
                                        onChange={(e) => setResvFinishTime(e.value)}
                                    />
                                </div>

                            </Fieldset>

                        </div>
                        <div className="p-mt-4">
                            <Fieldset legend="Rezervasyon Açıklaması" toggleable>
                                <div className="p-col-12 p-md-12">
                                    <InputTextarea value={resvReason}
                                                   placeholder="Rezervasyon açıklaması giriniz"
                                                   onChange={(e) => setResvReason(e.target.value)}
                                                   rows={5} cols={30}/>
                                </div>
                            </Fieldset>

                        </div>

                        <div className="p-col-12 p-md-12" align="center">

                            <div className="p-mt-2">

                                <Button label="Rezervasyon Oluştur" icon="pi pi-check"
                                        className="p-button-success"
                                        onClick={submit}
                                        style={{height: '40px', width: '25%'}}/>
                            </div>
                        </div>
                    </div>
                </div>


            </Card>

            <Dialog header="Bilgi" visible={infoDialog} style={{width: '75%'}} breakpoints={{'960px': '100%'}}
                    onHide={() => setInfoDialog(false)}
                    dismissableMask
            >
                <div className="p-fluid p-grid">
                    <div className="p-col-12 carousel-demo" align="center" style={{width: '100%'}}>
                        <Carousel value={products} numVisible={1} numScroll={1} page={0}
                                  style={{width: '100%'}} itemTemplate={productTemplate}
                        />
                        {/*<p>
                    Rezervasyon talebinde bulunmak için öncelikle kredi talebinizin olması gerekmektedir.
                    Sayfanın sağ tarafında yer alan <b>"Kredi Miktarı Hesaplama Aracı"</b> alanında
                    oluşturacağımız
                    rezervasyon sırasında
                    kullanılabilecek şablonlar ve tarih seçim alanları yer almaktadır. İlk olarak kullanılmak
                    istenen
                    şablon seçilir. Daha sonra hangi tarihler arasında kullanılacağı
                    seçilir. <b>"Hesapla"</b> butonuna
                    tıklanır.
                    <b>"Hesapla"</b> butonu üzerinde <b>"Hesaplanan Kredi Miktarı: --"</b> Şeklinde bir mesaj
                    alınır.
                    İstenen miktar
                    sayfanın sol kısmında yer alan <b>"Kredi Miktarı"</b> alanına girilir.
                    Bu alanına altında bulunan <b>"Talep Açıklaması"</b> alanına krediyi talep etme amacımızı
                    belirtmek için açıklama girilir.
                    <b>"Talep Oluştur" </b>
                    butonuna tıklanarak talep oluşturulur.
                </p>*/}
                    </div>
                </div>


            </Dialog>


        </div>
    )


}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
        return {
            putMethod: (data, url, type) => {
                return dispatch(management.putMethod(data, url, type));
            },
            postMethod: (data, url, type) => {
                return dispatch(management.postMethod(data, url, type));
            },
            deleteMethod: (data, url, type) => {
                return dispatch(management.deleteMethod(data, url, type));
            },
            logout: () => dispatch(auth.logout()),
            loadUser: () => {
                return dispatch(auth.loadUser());
            },

        }
    }
;

export default connect(mapStateToProps, mapDispatchToProps)(ReservationRequest);



// WEBPACK FOOTER //
// ./src/pages/systemmanagement/ReservationRequest.jsx